/**
 * The key used to store the store-level permissions map in localStorage.
 */
export var LOCAL_STORAGE_STORE_LEVEL_KEY = 'storeLevelPermissionsMap';
/**
 * The key used to store the merchant-level permissions map in localStorage.
 */
export var LOCAL_STORAGE_MERCHANT_LEVEL_KEY = 'merchantLevelPermissionsMap';
/**
 * A constant representing the store level in the permission system.
 */
export var STORE_LEVEL = 'zeus_store';
/**
 * A constant representing the merchant level in the permission system.
 */
export var MERCHANT_LEVEL = 'zeus_merchant';
/**
 * A constant representing the virtual entity level in the permission system.
 */
export var VIRTUAL_ENTITY_LEVEL = 'zeus_virtual_entity';
/**
 * A flag indicating whether the user permission system is used.
 */
export var USER_PERMISSION_FLAG = 'mexPortalUserPermissionSystem';
/**
 * A flag indicating whether the virtual entity system is sued
 */
export var VIRTUAL_ENTITY_FLAG = "mexPortalVirtualEntitySystem";
/**
 * Enumeration of possible actions for permissions.
 * Used to specify what kind of operation (GET, EDIT, CREATE, DELETE) a permission relates to.
 */
export var PERMISSION_ACTION;
(function (PERMISSION_ACTION) {
    PERMISSION_ACTION["GET"] = "get";
    PERMISSION_ACTION["EDIT"] = "edit";
    PERMISSION_ACTION["CREATE"] = "create";
    PERMISSION_ACTION["DELETE"] = "delete";
})(PERMISSION_ACTION || (PERMISSION_ACTION = {}));
/**
 * Enumeration of different modules or sections of the application for which permissions can be set.
 * Includes modules like DASHBOARD, INSIGHTS, FINANCE, etc.
 */
export var PERMISSION_MODULE;
(function (PERMISSION_MODULE) {
    PERMISSION_MODULE["DASHBOARD"] = "dashboard";
    PERMISSION_MODULE["INSIGHTS"] = "insights";
    PERMISSION_MODULE["FINANCE"] = "finance";
    PERMISSION_MODULE["INVENTORY"] = "inventory";
    PERMISSION_MODULE["MENU"] = "menu";
    PERMISSION_MODULE["FEEDBACK"] = "feedback";
    PERMISSION_MODULE["MARKETING"] = "marketing";
    PERMISSION_MODULE["ORDERS"] = "orders";
    PERMISSION_MODULE["EMPLOYEE_MANAGEMENT"] = "employee_management";
    PERMISSION_MODULE["EMPLOYEE_MANAGEMENT_EMPLOYEE"] = "employee_management/employee";
})(PERMISSION_MODULE || (PERMISSION_MODULE = {}));
//# sourceMappingURL=index.js.map